module.exports = __webpack_public_path__ + "static/media/product-detail-layout-button-four.72d6786f.png";